import { FormStatus } from '../../../../../../../../types/form';
import { getDocumentWithAction } from '../../../../../../../../apis/users/documents';

export const transformFieldGroup = (item: any) => {
  if (!item) {
    return null;
  }
  const dataArray: any[] = [];
  Object.keys(item).forEach((key) =>
    dataArray.push({
      label: key,
      value: item[key],
    })
  );
  return dataArray;
};

export const getFileUrl = async (id: string) => {
  if (!id) {
    return null;
  }
  const { file, action } = await getDocumentWithAction(id, true);
  const objectUrl = window.URL.createObjectURL(file);
  if (action === 'download') {
    const link = document.createElement('a');
    link.href = objectUrl;
    link.setAttribute('download', file.name);
    document.body.appendChild(link);
    link.click();
    link.remove();
  } else {
    window.open(objectUrl, '_blank');
  }
};

export const changeOrder = (fields: Record<string, any>): Record<string, any> => {
  return 'fileUpload' in fields ? Object.assign({ fileUpload: fields['fileUpload'] }, fields) : fields;
};

export const getAdminVerifyDocumentsConfirmMessage = (status: string) =>
  status === FormStatus.NeedsCorrection
    ? "Marking this as 'Needs Correction' will permanently delete the document. This action cannot be undone. Ensure this document is incorrect before continuing"
    : 'Once you save, you will not be able to edit. Are you sure you want to proceed?';
